import styled from 'styled-components'

const BottomRight = styled.div`
  display: flex;
  flex-direction: column;
  position: fixed;
  bottom: 35px;
  right: 35px;
`

export default BottomRight
